import { Analytics } from '@matap/shared';
import { Stream } from './stream';

export class PeerRemoteStream extends Stream<'change' | 'analytic'> {
  private readonly sessionId: string;
  private userId: string;
  public mediaStream?: MediaStream;

  // FIX 3: Keep track of bound tracks to prevent duplicate analytic listeners
  private boundTracks = new Set<string>();

  constructor(userId: string, sessionId: string) {
    super();
    this.userId = userId;
    this.sessionId = sessionId;
  }

  public setRemoteStream(stream: MediaStream) {
    // Prevent memory leaks if the stream is overwritten
    /* if (this.mediaStream && this.mediaStream !== stream) {
      this.mediaStream.getTracks().forEach((t) => t.stop());
    }*/

    this.mediaStream = stream;

    // FIX 1: Listen for orphaned tracks appended dynamically by P2PPeer
    stream.addEventListener('addtrack', (e) => {
      this.bindTrack(e.track);
      this.emit('change', stream); // Force the UI to re-render to show the new video!
    });

    stream.addEventListener('removetrack', () => {
      this.emit('change', stream); // Force UI update if remote drops a track
    });

    // Bind initial tracks
    stream.getTracks().forEach((t) => this.bindTrack(t));

    this.emit('change', stream);
  }

  // Helper method to safely bind listeners to a single track
  private bindTrack(t: MediaStreamTrack) {
    if (this.boundTracks.has(t.id)) return;
    this.boundTracks.add(t.id);

    this.emit('analytic', new Analytics.TrackCreated(this.sessionId, { kind: t.kind as any, local: false }));

    t.addEventListener('mute', () => this.emit('analytic', new Analytics.TrackStateChange(this.sessionId, { kind: t.kind as any, local: false, enabled: false })));
    t.addEventListener('unmute', () => this.emit('analytic', new Analytics.TrackStateChange(this.sessionId, { kind: t.kind as any, local: false, enabled: true })));

    // FIX 2: Added missing 'ended' listener so backend knows when remote drops camera/mic
    t.addEventListener('ended', () => this.emit('analytic', new Analytics.TrackStopped(this.sessionId, { kind: t.kind as any, local: false })));
  }

  public stream(): MediaStream | undefined {
    return this.mediaStream;
  }

  protected onDestroy() {
    this.mediaStream?.getTracks().forEach((t) => {
      //   t.stop();
      this.emit(
        'analytic',
        new Analytics.TrackStopped(this.sessionId, {
          kind: t.kind as any,
          local: false,
        }),
      );
    });

    // Clear references to allow Garbage Collection
    this.mediaStream = undefined;
    this.boundTracks.clear();
  }
}
